import { render, staticRenderFns } from "./ArticlesSection.vue?vue&type=template&id=5888d054&scoped=true"
import script from "./ArticlesSection.vue?vue&type=script&lang=js"
export * from "./ArticlesSection.vue?vue&type=script&lang=js"
import style0 from "./ArticlesSection.vue?vue&type=style&index=0&id=5888d054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5888d054",
  null
  
)

export default component.exports